"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constant = require("@airasia/phoenix-components/components/Theme/constant");
var _constant2 = require("./constant");
var _default = {
  PropTypes: {
    theme: _propTypes.default.string,
    data: _propTypes.default.shape({
      route: _propTypes.default.shape({
        origin: _propTypes.default.string,
        destination: _propTypes.default.string
      }),
      date: _propTypes.default.shape({
        departDate: _propTypes.default.string,
        returnDate: _propTypes.default.string
      }),
      passengers: _propTypes.default.shape({
        adult: Number(''),
        children: Number(''),
        infant: Number('')
      }),
      tripType: _propTypes.default.string,
      deepLinkUrl: _propTypes.default.string
    }),
    customProperties: _propTypes.default.object,
    tripType: _propTypes.default.string,
    accessible: _propTypes.default.bool,
    translation: _propTypes.default.shape({
      passengers: _propTypes.default.string,
      adult: _propTypes.default.string,
      adults: _propTypes.default.string
    }),
    isIconEnabled: _propTypes.default.bool,
    showDateLabel: _propTypes.default.bool,
    showBack: _propTypes.default.bool,
    isFlightInfo: _propTypes.default.bool,
    boxShadow: _propTypes.default.bool,
    isMobile: _propTypes.default.bool,
    locale: _propTypes.default.string,
    showEditText: _propTypes.default.bool,
    showCurrencyCTA: _propTypes.default.bool,
    editTextCallback: _propTypes.default.func,
    backIconCallback: _propTypes.default.func,
    currencyCallback: _propTypes.default.func
  },
  DefaultProps: {
    theme: _constant.DEFAULT_THEME,
    accessible: true,
    translation: _constant2.PASSENGER_TERMS,
    tripType: 'R',
    isIconEnabled: false,
    showDateLabel: false,
    showBack: true,
    isFlightInfo: false,
    boxShadow: true,
    isMobile: true,
    showEditText: true,
    showCurrencyCTA: true,
    editTextCallback: function editTextCallback() {},
    backIconCallback: function backIconCallback() {},
    currencyCallback: function currencyCallback() {}
  }
};
exports.default = _default;